import { Constants } from "../constants/constants";

export class PageConfiguration {
  PageNumber: number;
  PageSize: number;
  OrderBy: string;
  IsAscending: boolean;
  TotalRecords: number;

  constructor(orderBy: string, isAscending: boolean, pageSize?: number) {
    this.PageNumber = Constants.DefaultPageNumber;
    this.OrderBy = orderBy;
    this.IsAscending = isAscending;

    if (pageSize) {
      this.PageSize = pageSize;
    } else {
      this.PageSize = Constants.DefaultPageSize;
    }
  }
}
